import {Component, OnInit} from '@angular/core';
import {
  cfgDrawParameter,
  DrawParameterObj,
  DrawTextDefaults,
  LeadToolsHelper
} from '../../../models/configuration/draw/annotation-defaults.model';
import {TdoColorPickerEvent} from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import {DrawDefaultsService} from '../draw-defaults/draw-defaults.service';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {ConfigurationService} from '../configuration.service';
import { MatSnackBar } from '@angular/material/snack-bar';

const ParamName = 'DEFAULT_TEXT_TOOLS';

@Component({
  selector: 'app-draw-text-tools',
  templateUrl: './draw-text-tools.component.html',
  styleUrls: ['./draw-text-tools.component.css']
})
export class DrawTextToolsComponent implements OnInit {
  leadToolsHelper: LeadToolsHelper = new LeadToolsHelper();
  FontSizes = [];
  Widths = [];
  enumFonts = [];
  enumFontStyles = [];

  // Text
  fontTxt: number;
  fontNameTxt: string;
  fontSizeTxt: number;
  fontStyleTxt: string;
  foregroundTxt: string;
  backgroundTxt: string;
  borderColorTxt: string;
  lineWidthTxt: number;
  // Text Pointer
  fontTxtPtr: number;
  fontNameTxtPtr: string;
  fontSizeTxtPtr: number;
  fontStyleTxtPtr: string;
  foregroundTxtPtr: string;
  backgroundTxtPtr: string;
  borderColorTxtPtr: string;
  lineWidthTxtPtr: number;

  public drawParameter: cfgDrawParameter;
  public drawTextDefaults: DrawTextDefaults;
  constructor(private drawDefaultService: DrawDefaultsService, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) {
    this.enumFonts = this.leadToolsHelper.enumFonts;
    this.enumFontStyles = this.leadToolsHelper.enumFontStyles;
}

  getDrawParameters(parameterName: string) {
    return new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
  }

  ngOnInit(): void {
    this.FontSizes = this.leadToolsHelper.FontSizes;
    this.Widths = this.leadToolsHelper.Widths;
    this.getDrawParameters(ParamName)
      .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if(this.drawParameter != null) {
        this.drawTextDefaults = JSON.parse(this.drawParameter.ParameterValue);

        // Text
        this.fontTxt = this.drawTextDefaults.fontTxt;
        this.fontNameTxt = this.drawTextDefaults.fontNameTxt;
        this.fontSizeTxt = this.drawTextDefaults.fontSizeTxt;
        this.fontStyleTxt = this.drawTextDefaults.fontStyleTxt;
        this.foregroundTxt = this.drawTextDefaults.foregroundTxt;
        this.backgroundTxt = this.drawTextDefaults.backgroundTxt;
        this.borderColorTxt = this.drawTextDefaults.borderColorTxt;
        this.lineWidthTxt = this.drawTextDefaults.lineWidthTxt;
        // Text Pointer
        this.fontTxtPtr = this.drawTextDefaults.fontTxtPtr;
        this.fontNameTxtPtr = this.drawTextDefaults.fontNameTxtPtr;
        this.fontSizeTxtPtr = this.drawTextDefaults.fontSizeTxtPtr;
        this.fontStyleTxtPtr = this.drawTextDefaults.fontStyleTxtPtr;
        this.foregroundTxtPtr = this.drawTextDefaults.foregroundTxtPtr;
        this.backgroundTxtPtr = this.drawTextDefaults.backgroundTxtPtr;
        this.borderColorTxtPtr = this.drawTextDefaults.borderColorTxtPtr;
        this.lineWidthTxtPtr = this.drawTextDefaults.lineWidthTxtPtr;
        }
        else {
          this.setDefaultValues();
          this.drawTextDefaults = new DrawTextDefaults();
          this.saveDefaultValues();
        }

      }, err => {
        this.setDefaultValues();
        this.drawTextDefaults = new DrawTextDefaults();
        this.saveDefaultValues();
      });

  }



  setDefaultValues() {
    // Text
    this.fontTxt = 0;
    this.fontSizeTxt = 12;
    this.fontStyleTxt = '0';
    this.foregroundTxt = '#f05b41';
    this.backgroundTxt = '#5341f0';
    this.borderColorTxt = '#417CF0';
    this.lineWidthTxt = 7;
    // TxtPtr
    this.fontTxtPtr = 0;
    this.fontSizeTxtPtr = 12;
    this.fontStyleTxtPtr = '0';
    this.foregroundTxtPtr = '#f05b41';
    this.backgroundTxtPtr = '#5341f0';
    this.borderColorTxtPtr = '#417CF0';
    this.lineWidthTxtPtr = 7;

  }
  saveDefaultValues() {
    this.drawTextDefaults.fontTxt = this.fontTxt;
    this.drawTextDefaults.fontSizeTxt = this.fontSizeTxt;
    this.drawTextDefaults.fontStyleTxt = this.fontStyleTxt;
    this.drawTextDefaults.foregroundTxt = this.foregroundTxt;
    this.drawTextDefaults.backgroundTxt = this.backgroundTxt;
    this.drawTextDefaults.borderColorTxt = this.borderColorTxt;
    this.drawTextDefaults.lineWidthTxt = this.lineWidthTxt;
    // Text Pointer
    this.drawTextDefaults.fontTxtPtr = this.fontTxtPtr;
    this.drawTextDefaults.fontSizeTxtPtr = this.fontSizeTxtPtr;
    this.drawTextDefaults.fontStyleTxtPtr = this.fontStyleTxtPtr;
    this.drawTextDefaults.foregroundTxtPtr = this.foregroundTxtPtr;
    this.drawTextDefaults.backgroundTxtPtr = this.backgroundTxtPtr;
    this.drawTextDefaults.borderColorTxtPtr = this.borderColorTxtPtr;
    this.drawTextDefaults.lineWidthTxtPtr = this.lineWidthTxtPtr;

  }

  onForegroundColorChangeTxt(event: TdoColorPickerEvent) {
    this.foregroundTxt = event.hex;
  }
  onBackgroundColorChangeTxt(event: TdoColorPickerEvent) {
    this.backgroundTxt = event.hex;
  }
  onFontChangeTxt(e) {
    this.fontTxt = e.value.value;
    this.fontNameTxt = e.value.name;
  }
  onFontSizeChangeTxt(e) {
    this.fontSizeTxt = e.value.value;
  }
  onFontStyleChangeTxt(e) {
    this.fontStyleTxt = e.value.value;
  }
  onWidthChangeTxt(e) {
    this.lineWidthTxt = e.value.value;
  }
  onBorderColorChangeTxt(event: TdoColorPickerEvent) {
    this.borderColorTxt = event.hex;
  }

  onForegroundColorChangeTxtPtr(event: TdoColorPickerEvent) {
    this.foregroundTxtPtr = event.hex;
  }
  onBackgroundColorChangeTxtPtr(event: TdoColorPickerEvent) {
    this.backgroundTxtPtr = event.hex;
  }
  onFontChangeTxtPtr(e) {
    this.fontTxtPtr = e.value.value;
    this.fontNameTxtPtr = e.value.name;
  }
  onFontSizeChangeTxtPtr(e) {
    this.fontSizeTxtPtr = e.value.value;
  }
  onFontStyleChangeTxtPtr(e) {
    this.fontStyleTxtPtr = e.value.value;
  }
  onWidthChangeTxtPtr(e) {
    this.lineWidthTxtPtr = e.value.value;
  }
  onBorderColorChangeTxtPtr(event: TdoColorPickerEvent) {
    this.borderColorTxtPtr = event.hex;
  }

  async onSave(e) {
    this.saveDefaultValues();
    const drawParam = new DrawParameterObj();
    drawParam.parameterName = ParamName;
    const annDefaults = JSON.stringify(this.drawTextDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults('00000000-0000-0000-0000-000000000000', drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  dropdownChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }
}
